import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import { getCategoryName, formatViews } from "@/utils/catalog";

interface MovieCardProps {
  movie: Movie;
  showSynopsis?: boolean;
}

export default function MovieCard({ movie, showSynopsis = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block overflow-hidden rounded-lg bg-background-100 ring-1 ring-background-200/70 transition hover:ring-accent-500/60"
      data-product-shop
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title}电影海报`}
          title={`${movie.title} - 电影天堂`}
          className="h-full w-full object-top transition duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/10 to-transparent" />
        <span className="absolute right-2 top-2 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-background-950">
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-2 left-2 rounded-md bg-background-950/70 px-2 py-0.5 text-xs text-background-50">
          {movie.year}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-medium text-foreground-50 transition group-hover:text-accent-400 md:text-base">
          {movie.title}
        </h3>
        {showSynopsis && (
          <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-400">
            {movie.synopsis}
          </p>
        )}
        <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-foreground-400">
          <span className="truncate">{movie.genres.map(getCategoryName).join(" · ")}</span>
        </div>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
          <span>{movie.region}</span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-accent-500" />
            {formatViews(movie.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}